// extracted by mini-css-extract-plugin
export default {"policiesContainer":"xOMjP","minimalContainer":"mOo2q","mobilePoliciesContainer":"hChQh","desktopPoliciesContainer":"_33b+4","policiesLink":"_1MB-e"};